ui-bank-search-list-item {
  display: block;

  p {
    margin-top: $sd-spacing-1;
  }

  .sr-only {
    @include sr-only;
  }

  .bank-search-list-item-container {
    &.cursor-pointer {
      cursor: pointer;
    }

    &:focus {
      outline: 2px solid $sd-borderColor-primary-DEFAULT;
      box-sizing: border-box;
      outline-offset: -2px;
    }
  }

  .bank-details {
    display: flex;
    padding: $sd-spacing-4;
    border-bottom: 1px solid $sd-borderColor-neutral-200;
    flex-flow: wrap;
    row-gap: $sd-spacing-3;

    @include breakpoint($xlarge) {
      flex-wrap: nowrap;
    }

    background-color: $sd-backgroundColor-white;

    &:hover,
    &.hover {
      background-color: $sd-backgroundColor-primary-100;
      border-bottom-color: $sd-borderColor-primary-200;
    }

    &.selected {
      background-color: $sd-backgroundColor-primary-100;
      border-bottom-color: $sd-borderColor-primary-200;
    }

    &__logo {
      width: 1.875rem;
      margin-top: $sd-spacing-2;
      margin-right: $sd-spacing-5;
      text-align: center;
      flex-shrink: 0;

      ui-cms-image {
        display: inline-block;
        margin: 0 auto;
        width: auto;
        min-width: 1.125rem;
        max-width: 1.875rem;
      }
    }

    &__distance {
      flex-shrink: 0;

      p {
        margin-top: $sd-spacing-1;
        color: $sd-textColor-neutral-600;
      }
    }

    &__info {
      margin-right: $sd-spacing-6;
      max-width: 250px;
      flex-grow: 1;
    }

    &__onlinebanking {
      white-space: nowrap;
      width: 100%;
      display: flex;
      justify-content: right;

      @include breakpoint($xlarge) {
        width: auto;
      }
    }
  }

  .bank-details--light {
    padding-left: $sd-spacing-10;
    padding-right: $sd-spacing-10;
  }
}
